module.exports = __webpack_public_path__ + "static/media/38.f7cad3c2.jpeg";